(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-services-mega"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-services-nav]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const button = nav.querySelector('.tt-services-toggle');
      const panel = nav.querySelector('.tt-mega-panel');
      const desktop = matchMedia('(min-width:801px)');
      let timer;
      const setOpen = open => { clearTimeout(timer); panel.hidden = !open; button.setAttribute('aria-expanded', String(open)); };
      nav.addEventListener('pointerenter', event => { if (desktop.matches && event.pointerType !== 'touch') setOpen(true); });
      nav.addEventListener('pointerleave', () => { if (!nav.contains(document.activeElement)) timer = setTimeout(() => setOpen(false), 160); });
      button.addEventListener('click', () => setOpen(panel.hidden));
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); setOpen(false); button.focus(); }
        if (event.key === 'ArrowDown' && event.target !== panel && !panel.contains(event.target)) { event.preventDefault(); setOpen(true); panel.querySelector('a').focus(); }
      });
      nav.addEventListener('focusout', () => setTimeout(() => { if (!nav.contains(document.activeElement)) setOpen(false); }, 0));
      document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) setOpen(false); });
      desktop.addEventListener('change', () => setOpen(false));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
